var _path, _circle, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAvailability = function SvgAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.078 17.96h-5.445l-8.528 8.528v5.445l8.528 8.528h5.445l8.528-8.528v-5.445l-8.528-8.528Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62.764,
    cy: 66.623,
    r: 11.426,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.135 44.227V30.732l-2.228-2.045H40.368M27.57 47.883v17.623l2.355 1.574h21.412",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m70.908 40.227-5.134 5.134h-3.278l-5.134-5.134M34.344 53.742l-5.135-5.134h-3.277l-5.134 5.134",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgAvailability;